<template>
  <span
    class="relative z-10 inline-block leading-none fill-current stroke-current"
  >
    <span
      :class="active ? null : 'text-opacity-40'"
      class="text-black transition transition-color duration-200"
    >
      <slot />
    </span>
    <span
      :class="active ? null : 'text-transparent'"
      :style="style"
      class="absolute z-under transition transition-color duration-200"
    >
      <svg
        class="w-full h-full overflow-visible"
        viewBox="0 0 200 100"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          v-if="type === 'circle-fill'"
          d="M47.708 12.364c-4.194.678-8.316 1.632-12.438 2.712-3.929 1.03-7.882 2.084-11.666 3.59-3.977 1.608-7.906 3.541-11.305 6.203C7.912 28.309 3.863 32.603 1.79 38c-2.24 5.826-2.675 12.48.435 18.079 1.253 2.26 3.013 4.269 4.58 6.328.626.803 1.18 1.682 1.928 2.36.892.803 1.832 1.557 2.723 2.335 1.688 1.456 3.375 2.938 5.11 4.369 1.88 1.557 4.002 2.837 6.099 4.068a80.7 80.7 0 0010.919 5.373c2.17.879 4.387 1.507 6.556 2.335 2.17.829 4.29 1.758 6.484 2.511a110.162 110.162 0 0014.92 3.993c-.506-.126-1.012-.251-1.542-.377a333.895 333.895 0 0042.158 7.935c13.643 1.657 27.454 2.762 41.218 2.686 8.219-.05 16.414-.678 24.538-2.033-.555.075-1.085.15-1.64.226 2.29-.176 4.58-.478 6.798-1.005 1.856-.427 3.591-1.155 5.399-1.758 3.712-1.205 7.328-2.536 10.534-4.946 1.373-1.03 2.747-2.06 3.856-3.39.868-1.055 1.567-2.184 2.314-3.34.579-.903 1.181-1.782 1.736-2.686 1.108-1.783 1.928-3.59 2.265-5.675.145-.879.217-1.732.314-2.586.217-2.536.795-5.374.337-7.885-.385-2.059-1.012-4.168-1.856-6.076-1.422-3.264-3.567-6.328-6.243-8.587-1.35-1.13-2.41-2.511-3.664-3.742-1.566-1.532-3.254-2.887-4.989-4.193-1.422-1.08-2.941-2.009-4.459-2.913-1.591-.954-3.062-2.21-4.604-3.264a100.653 100.653 0 00-9.642-5.85c-7.014-3.767-14.414-6.378-21.838-9.09-3.905-1.431-7.834-2.863-11.739-4.294-3.88-1.431-8.002-2.335-11.955-3.44-8.292-2.335-16.536-4.746-24.924-6.629-7.93-1.782-15.933-3.038-23.96-4.243C61.93 1.392 53.83.337 45.708.086c-8.026-.251-16.487-.05-24.32 1.958-1.929.402-3.737 1.03-5.496 1.783-1.929.829-3.375 1.934-4.604 3.716-1.23 1.758-2.242 4.37-2.29 6.579-.048 1.783.12 3.992 1.47 5.298 1.157 1.13 2.868 1.808 4.435 1.155 3.52-1.506 7.207-2.385 10.968-2.887-.555.075-1.085.15-1.64.226 9.256-1.155 18.657-.88 27.913.075 9.376.98 18.777 2.335 28.033 4.068 5.303.979 10.558 2.134 15.788 3.465-.506-.126-1.012-.251-1.543-.377 5.858 1.482 11.643 3.214 17.476 4.846 2.916.829 5.833 1.657 8.75 2.46 2.916.83 5.76 1.96 8.605 3.014 10.726 3.942 21.549 7.508 31.48 13.383a111.96 111.96 0 017.64 4.972c1.302.93 2.555 1.833 3.905 2.637a42.575 42.575 0 013.712 2.536c-.434-.327-.843-.653-1.277-.98 2.242 1.758 4.073 3.817 6.074 5.85.844.88 1.88 1.583 2.724 2.487.868.904 1.615 1.908 2.29 2.963-.29-.478-.603-.954-.892-1.432a21.927 21.927 0 012.338 5.349 48.312 48.312 0 01-.482-1.808c.072.25.144.502.193.728.072.301.192 1.456.144.176-.048-1.306-.072-.15-.096.15-.048.402-.072.829-.121 1.23-.12 1.482-.265 2.964-.385 4.47.771-2.184 1.518-4.369 2.29-6.578-.627.979-1.254 1.933-1.881 2.912-.361.553-.747 1.105-1.06 1.657-.53.779-.338.578.554-.602-.458.377-.409.351.145-.126 1.157-.929-.265.176-.506.352-.386.276-.772.527-1.157.778-.844.528-1.712.98-2.604 1.406.555-.25 1.085-.502 1.64-.753-1.977.904-4.074 1.456-6.123 2.185-2.193.803-4.459 1.33-6.749 1.657.554-.075 1.085-.15 1.639-.226-2.675.351-5.327.703-8.002 1.08.554-.076 1.084-.151 1.639-.226-13.065 1.682-26.25 1.33-39.362.426-13.113-.878-26.177-2.385-39.145-4.695a303.073 303.073 0 01-21.573-4.645c.506.125 1.012.25 1.543.376-2.41-.602-4.845-1.08-7.232-1.682.507.126 1.013.251 1.543.377a103.838 103.838 0 01-9.834-3.039c-1.543-.577-3.062-1.205-4.604-1.833-1.543-.627-3.182-1.054-4.749-1.657-6.195-2.285-12.076-5.373-17.572-9.09.434.327.844.653 1.278.98-2.483-2.134-4.966-4.244-7.472-6.378-1.206-1.03-2.097-2.31-3.062-3.59-.988-1.306-2-2.612-2.988-3.943.289.477.602.954.891 1.431-.578-1.08-1.06-2.159-1.422-3.34.169.603.338 1.206.482 1.809-.144-.553-.217-1.08-.313-1.632-.265-1.432-.12 1.807.024.452.217-2.16-.506 1.632-.072.226.072-.277.144-.528.217-.779-.17.502-.338.98-.506 1.482a7.48 7.48 0 01.337-.779c.41-.828.241-.527-.53.904.24-.326.458-.728.675-1.054.433-.628 1.76-1.884-.193.1.313-.326.602-.703.94-1.03.313-.326.65-.652.988-.979.217-.2 1.59-1.33.41-.401-1.181.929.24-.176.482-.352.386-.276.747-.527 1.133-.803a43.555 43.555 0 015.158-2.888c-.554.251-1.085.502-1.639.753 4.122-1.908 8.46-3.164 12.823-4.319 4.532-1.205 9.088-2.285 13.691-3.038 1.736-.276 3.664-2.36 4.604-3.716 1.23-1.758 2.242-4.37 2.29-6.579.048-1.782-.12-3.992-1.47-5.298-1.278-1.255-2.652-1.406-4.387-1.105z"
          stroke="none"
        />
        <g
          v-else
          fill="none"
          :stroke-width="strokeWidth || 1"
          stroke-linecap="square"
        >
          <path
            v-if="type === 'circle-stroke'"
            d="M27.41 27.829c-7.223.64-15.806 1.493-22.246 11.488C3.071 42.565-1.237 53.183.34 60.835 1.722 67.54 4.318 71.39 6.873 73.873c8.188 7.959 17.413 11.658 25.964 14.862 36.727 13.758 74.939 12.8 111.899 8.206 13.713-1.704 27.695-3.365 41.309-8.57 4.08-1.56 9.732-4.012 13.167-11.489 6.122-13.329-25.386-39.975-26.601-40.847-18.93-13.586-38.547-20.355-57.96-26.168C93.931 3.663 73.13-.768 52.269.111c-8.939.377-18.606 1.016-27.472 5.38-2.746 1.351-1.188 1.612-.402 4.285"
            vector-effect="non-scaling-stroke"
          />
          <path
            v-else-if="type === 'line-a'"
            d="M0 31.094C47.217 9.604 94.516.676 141.848.087c15.7-.196 62.802 0 47.101 0-11.652 0-23.389 8.313-35.024 11.867-28.856 8.816-57.225 27.483-85.9 48.234-8.97 6.491-17.944 17.44-26.932 22.394-2.852 1.572 5.712-2.871 8.575-3.062 32.608-2.176 65.3-2.513 97.886 5.55C165.02 89.392 182.516 100 200 100"
            vector-effect="non-scaling-stroke"
          />
          <path
            v-else-if="['line-b', 'line-c'].includes(type)"
            d="M12 40.094c47.217-21.49 94.516-30.418 141.848-31.007 15.7-.196 62.802 0 47.101 0-11.652 0-23.389 8.313-35.024 11.867-28.856 8.816-57.225 27.483-85.9 48.234-8.97 6.491-17.944 17.44-26.932 22.394-2.852 1.572 5.712-2.871 8.575-3.062 32.608-2.176 65.3-2.513 97.886 5.55C177.02 98.392 194.516 109 212 109"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </svg>
    </span>
  </span>
</template>

<script>
export default {
  name: 'TextMarker',
  props: {
    active: {
      default: true,
      type: Boolean,
    },
    strokeWidth: {
      default: null,
      type: [Number, String],
    },
    type: {
      required: true,
      type: String,
    },
  },
  computed: {
    style() {
      const style = {
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
      };

      switch (this.type) {
        case 'circle-fill':
          style.top = '-0.07em';
          style.left = '-0.17em';
          style.right = '-0.02em';
          style.bottom = '-0.25em';
          break;
        case 'circle-stroke':
          style.top = '0.1em';
          style.left = '-0.15em';
          style.right = '0.15em';
          style.bottom = '-0.1em';
          break;
        case 'line-a':
          style.top = '0.92em';
          style.right = '0.25em';
          style.bottom = '-0.2em';
          break;
        case 'line-b':
          style.top = '0.4em';
          style.left = '0.15em';
          style.right = '0.2em';
          style.bottom = '0.25em';
          break;
        case 'line-c':
          style.top = '0.9em';
          style.left = '-0.2em';
          style.right = '0.3em';
          style.bottom = '0em';
          break;
        default:
          break;
      }

      return style;
    },
  },
  // mounted() {
  //   this.animation = anime({
  //     targets: this.$refs.svg.querySelector('path'),
  //     strokeDashoffset: [anime.setDashoffset, 0],
  //     duration: 600,
  //     easing: 'easeInOutQuad',
  //     autoplay: false
  //   })
  // }
};
</script>
